export const qualificationObject = () => {
  return {
    id: "",
    candidateId: "",
    qualificationId: "",
    degree: "",
    specialization: "",
    completionYear: "",
    grade: "",
    college: "",
    university: "",
    location: ""
  };
};

export const addressObject = () => {
  return {
    id: "",
    addressType: "",
    addressLine1: "",
    addressLine2: "",
    locality: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
    candidateId: ""
  };
};

export const organizationObject = () => {
  return {
    id: "",
    organizationName: "",
    jobTitle: "",
    joiningDate: "",
    lastWorkingDate: "",
    location: "",
    employeeCode: "",
    departmentName: "",
    lastOrganization: ""
  };
};

export const relationObject = () => {
  return {
    id: "",
    relationShipType: "",
    fullName: "",
    occupation: "",
    dateOfBirth: "",
    currentAddress: undefined,
    age: "",
    isFamilyMemberMinor: 0,
    isEPSNominee: 0,
    isMonthlyWidowPension: 0,
    candidateId: 0,
    isDeleted: 0
  };
};
